import { IAuctionServiceCost } from '../../../../../redux/reducers';
import { SERVICE_NAMES } from '../constants';

interface IGetNextLevelServiceMessageParams {
  isRaiseServiceLevelEnabled: boolean;
  nextServiceCost: IAuctionServiceCost | null;
}

export function getNextLevelServiceMessage(params: IGetNextLevelServiceMessageParams): string | null {
  const { isRaiseServiceLevelEnabled, nextServiceCost } = params;

  if (!isRaiseServiceLevelEnabled || !nextServiceCost) {
    return null;
  }

  return `С этой ставкой можно бесплатно перейти в ${SERVICE_NAMES[nextServiceCost.serviceId]}`;
}
